import { CallPageTypes } from 'common/Enums'
import { history } from 'store'
import { UrlsProvider } from 'utils/urlUtils'

export const navigateCallPage = ({ activeCalls = [], callPageType = null}) => {
    if (callPageType) return history.push(UrlsProvider.callUrlGenerator(callPageType))

    if (activeCalls.length > 1) {
        history.push(UrlsProvider.callUrlGenerator(CallPageTypes.Multi))
    } else {
        history.push(UrlsProvider.callUrlGenerator(CallPageTypes.Single))
    }
}